import { Map as map } from 'immutable';

import { createSelector } from '../utils/createSelector';
import { LOYALTY_MODULE_CONFIG, MODULE_ID } from '../constants';

export const getLoyaltyModuleConfig = (state) => state.getIn(['config', LOYALTY_MODULE_CONFIG]) || [];
export const getLocationFromProps = (_, props) => props?.location;

export const getPathname = createSelector(
  getLocationFromProps,
  (location) => location?.pathname || ''
);

export const getIsSSREnabled = createSelector(
  getLoyaltyModuleConfig,
  (loyaltyModuleConfig) => !global.BROWSER && loyaltyModuleConfig.indexOf(MODULE_ID) === -1
);

export const getPreloadModules = createSelector(
  getPathname,
  (pathname) => {
    switch (pathname) {
      case '/footer-only':
        return [{ name: 'axp-footer' }];

      case '/header-only':
        return [{ name: 'axp-global-header' }];

      case '/page-wrapper':
        return [{ name: 'axp-page-wrapper' }];

      case '/nav-only':
        return [{ name: 'axp-global-rewards-nav' }];

      case '/cmv':
        return [
          { name: 'axp-global-header' },
          { name: 'axp-global-rewards-nav' },
          { name: 'axp-rewards-use-points' },
          { name: 'axp-footer' },
        ];

      default:
        return [
          { name: 'axp-global-header' },
          { name: 'axp-footer' },
        ];
    }
  }
);

export const getConfigState = (state) => state.get('config', map());

export const getFaasApiUrl = createSelector(
  getConfigState,
  (configState) => configState.get('faasApiUrl')
);
